
import React from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';

const Home: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="container mx-auto py-8 px-4">
      <div className="text-center mb-8">
        <h1 className="text-4xl font-bold mb-4">Welcome to GrinGauge</h1>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto">
          Record videos, detect emotions, and share your experiences with merchants
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
        <Card className="shadow-lg hover:shadow-xl transition-shadow">
          <CardContent className="pt-6">
            <h2 className="text-2xl font-bold mb-4">Record a Video</h2>
            <p className="mb-6">Capture your experience and see your emotions in real-time</p>
            <Button
              onClick={() => navigate('/record')}
              className="w-full bg-yellow-600 hover:bg-yellow-700"
            >
              Start Recording
            </Button>
          </CardContent>
        </Card>

        <Card className="shadow-lg hover:shadow-xl transition-shadow">
          <CardContent className="pt-6">
            <h2 className="text-2xl font-bold mb-4">Video Wall</h2>
            <p className="mb-6">View videos from others and explore merchants</p>
            <Button
              onClick={() => navigate('/wall')}
              className="w-full bg-blue-600 hover:bg-blue-700"
            >
              View Videos
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Home;
